module.exports = __webpack_public_path__ + "static/media/banner2.50a3dfe2.png";